export * from './alignment';
export * from './user';
export * from './project';
export * from './organization';
export * from './fleet';
export * from './registration';
export * from './system';
export * from './options';
export * from './subscriptions';
export * from './tasks';
export * from './epic';
export * from './equipment';
export * from './file';
export * from './location';
export * from './issues';
export * from './workpackage';
export * from './positionDevice';
export * from './userGroup';
export * from './userGroupTypes';
export * from './pricingPlan';
export * from './notification';
export * from './service';
export * from './partners';
export * from './inspection';
export * from './operationHours';

export const ISACTIVE = (item: any): boolean => {
    const checkOne = (one: any) => {
        return (
            one &&
            ((one.loading && !(one.error || one.data)) ||
                (one.loading && one.networkStatus && one.networkStatus != 7))
        );
    };

    if (item) {
        if (item.constructor && item.constructor.name && item.constructor.name == 'Array') {
            for (let ii = 0; ii < item.length; ii++) {
                if (checkOne(item[ii])) {
                    return true;
                }
            }
        } else {
            return checkOne(item);
        }
    }

    return false;
};

/**
 * This function is used for the tracked loading events inside LoadingContextProvider. For events outside of the context use ISACTIVE method
 * @param graphqlOperations list of graphql operation results such as QueryResult or MutationResult
 * @returns boolean indicating if any of the operations are loading
 */
export const getContextLoadingState = (graphqlOperations: any): boolean => {
    const test = (operation: any) =>
        Boolean(
            !operation.loading ||
                operation.error ||
                operation.data ||
                (operation.networkStatus && operation.networkStatus === 7)
        );

    if (
        Array.isArray(graphqlOperations) &&
        graphqlOperations.every((operation) => operation != null)
    ) {
        return graphqlOperations.some((operation) => !test(operation));
    } else if (!Array.isArray(graphqlOperations) && graphqlOperations != null) {
        return test(graphqlOperations);
    } else {
        return false;
    }
};
